// CLARTEXT · /abo — Bühne „Lehrbilder + QR-Plakat" (zwischen B3 Handy/Computer
// und B4 Wiedervorlage). Betreiber-GO: 1a bauen · 2a Platzierung · 3a echte PDF
// über „Plakat ansehen" · 4a Lehrbilder UND QR gleichrangig · 5b keine Sprachen.
//
// Verkauft das Ergebnis, nicht die Funktion: „Arbeitsschutz, den man sehen kann."
// Das Bild erzählt die Geschichte (visual-learning = echte Produkt-UI, STAR).
// Mobile = eigene 390-px-Fassung (Kopf+QR-Crop, Lehrbild-Karten-Crop), kein
// verkleinerter Desktop. Copy = Arbeitsstand (NICHT eingefroren).
import { Image as ImageIcon } from "lucide-react";
import AboChris from "@/components/abo/AboChris";

const SHOT = (name) => `/abo/screenshots/${name}`;

export default function AboLehrbilderPlakatStage({ onViewPlakat }) {
  return (
    <section className="abo-stage abo-stage--lp" data-testid="abo-stage-lehrbilder">
      <div className="abo-stage-wrap">
        <header className="abo-lp-head reveal">
          <span className="abo-stage-kicker">Vom Bildschirm an die Wand</span>
          <h2 className="abo-stage-title" data-testid="abo-lehrbilder-title">
            Arbeitsschutz, den man sehen kann.
          </h2>
          <p className="abo-lp-sub" data-testid="abo-lehrbilder-sub">
            CLartext macht aus Ihrer Unterweisung anschauliche Lehrbilder und
            ein fertiges Plakat. An die Wand, auf die Maschinenkiste oder direkt
            an die Maschine – genau dort, wo auf die Unterweisung hingewiesen
            werden soll.
          </p>
        </header>

        <div className="abo-lp-stage reveal d1">
          <div className="abo-lp-proof" data-testid="abo-lehrbilder-proof">
            {/* Desktop: großer Star – die echte Plakat-Ansicht */}
            <figure className="abo-lp-shot--desktop abo-screenplate">
              <img
                src={SHOT("visual-learning.webp")}
                alt="CLartext Unterweisungsplakat „Bildschirmarbeitsplätze“: automatisch erzeugte Lehrbilder für Gefahren und richtiges Verhalten, mit QR-Code zum Scannen."
                data-testid="abo-shot-lehrbilder"
                loading="lazy"
                draggable="false"
              />
            </figure>
            {/* Mobile: eigene 390-Fassung – erst Kopf + QR, dann Lehrbild-Karten */}
            <div className="abo-lp-shot--mobile">
              <figure className="abo-screenplate">
                <img
                  src={SHOT("crops/lehrbild-kopf-qr.webp")}
                  alt="Unterweisungsplakat „Bildschirmarbeitsplätze“ mit QR-Code: scannen, PIN eingeben – die Dokumentationswelt öffnet sich auf dem Handy."
                  data-testid="abo-shot-lehrbilder-kopf"
                  loading="lazy"
                  draggable="false"
                />
              </figure>
              <figure className="abo-screenplate">
                <img
                  src={SHOT("crops/lehrbild-karten.webp")}
                  alt="Automatisch erzeugte Lehrbilder: Gefahren am Bildschirmarbeitsplatz auf einen Blick."
                  data-testid="abo-shot-lehrbilder-karten"
                  loading="lazy"
                  draggable="false"
                />
              </figure>
            </div>
          </div>

          <div className="abo-lp-side">
            <AboChris
              pose={19}
              size="lg"
              testId="abo-chris-lehrbilder"
              text="Ich bringe die Unterweisung dorthin, wo gearbeitet wird. Und über den QR-Code geht's direkt am Handy weiter."
            />
            <button
              type="button"
              className="abo-plakat-btn abo-lp-btn"
              data-testid="abo-plakat-view-lehrbilder"
              onClick={onViewPlakat}
            >
              <ImageIcon size={16} aria-hidden="true" />
              Plakat ansehen
            </button>
          </div>
        </div>

        <div className="abo-lp-foot reveal d2">
          <p className="abo-lp-benefit" data-testid="abo-lehrbilder-benefit">
            Ausdrucken. Aufhängen. Fertig.
          </p>
        </div>
      </div>
    </section>
  );
}
